import React, { useContext, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ModalContext } from '@/utils/contexts/ModalContext';

import { authActions } from '@/store/actions/auth.actions';
import api from '@/services/api';

import btu_logo from '@/assets/images/logo.svg';

import video1 from '@/assets/videos/onboarding/Wprowadzenie 1.mp4';
import video2 from '@/assets/videos/onboarding/Wprowadzenie 2.mp4';
import video3 from '@/assets/videos/onboarding/Wprowadzenie 3.mp4';
import video4 from '@/assets/videos/onboarding/Wprowadzenie 4.mp4';
import video5 from '@/assets/videos/onboarding/Wprowadzenie 5.mp4';

import styles from '@/views/components/Modal/Onboarding/ModalOnboarding.module.scss';

const ModalOnboarding = () => {
	const dispatch = useDispatch();

	const { dict } = useSelector((state) => state.app);
	const user = useSelector(state => state.auth.user);

	const { closeModal } = useContext(ModalContext);

	const [ page, setPage ] = useState(0);

	const finishIntroduction = () => {
		api.put(`/users/onboarding/${user.id}/false`).then(() => {
			api.get('/auth/me').then((response) => {
				dispatch(authActions.setUser(response.data));
				closeModal();
			});
		});
	};

	return (
		<div className='modal__content'>
			<div className={ styles['modal-onboarding__wrapper'] }>
				<div className={ styles['modal-onboarding__top'] }>
					<div className={ styles['modal-onboarding__top--header'] }>
						{page === 0 && dict.modals.onboarding.page0.header}
						{page === 1 && dict.modals.onboarding.page1.header}
						{page === 2 && dict.modals.onboarding.page2.header}
						{page === 3 && dict.modals.onboarding.page3.header}
						{page === 4 && dict.modals.onboarding.page4.header}
						{page === 5 && dict.modals.onboarding.page5.header}
					</div>
					<div 
						className={ styles['modal-onboarding__top--skip'] }
						onClick={ finishIntroduction }
					>
						{dict.modals.onboarding.skip}
					</div>
				</div>
				<div className={ styles['modal-onboarding__content'] }>
					{page === 0 && <>
						<div className={ styles['modal-onboarding__content__first-page__background'] }>
							<img 
								src={ btu_logo }
								className={ styles['modal-onboarding__content__first-page__background--logo'] } 
							/>
						</div>
						<p className={ styles['modal-onboarding__content__first-page--text'] }>
							{dict.modals.onboarding.page0.text}
						</p>
					</>}

					{page === 1 && <>
						<p>
							{dict.modals.onboarding.page1.text}
						</p>
						<ol>
							<li>{dict.modals.onboarding.page1.list.part1}</li>
							<li>{dict.modals.onboarding.page1.list.part2}</li>
							<li>{dict.modals.onboarding.page1.list.part3}</li>
						</ol>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video1 }
							/>
						</video>
					</>}

					{page === 2 && <>
						<p>
							<strong>{dict.modals.onboarding.page2.text.part1}</strong> {dict.modals.onboarding.page2.text.part2}
						</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video2 }
							/>
						</video>
					</>}

					{page === 3 && <>
						<p>
							{dict.modals.onboarding.page3.text.part1}<strong>{dict.modals.onboarding.page3.text.part2}</strong>{dict.modals.onboarding.page3.text.part3} <strong>{dict.modals.onboarding.page3.text.part4}</strong>.
						</p>
						<p>
							<strong>{dict.modals.onboarding.page3.text.part5}</strong> {dict.modals.onboarding.page3.text.part6}
						</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video3 }
							/>
						</video>
					</>}

					{page === 4 && <>
						<p>{dict.modals.onboarding.page4.text.part1}</p>
						<p><strong>{dict.modals.onboarding.page4.text.part2}</strong> {dict.modals.onboarding.page4.text.part3}</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video4 }
							/>
						</video>
					</>}

					{page === 5 && <>
						<p>{dict.modals.onboarding.page5.text.part1}</p>
						<p><strong>{dict.modals.onboarding.page5.text.part2}</strong>{dict.modals.onboarding.page5.text.part3}</p>
						<video 
							width="100%"
							controls 
						>
							<source 
								src={ video5 }
							/>
						</video>
					</>}
				</div>
				<div className={ styles['modal-onboarding__bottom'] }>
					{page === 0 && <>
						<button 
							className='button__blue'
							style={ { marginLeft: 'auto', gridColumnStart: 3 } }
							onClick={ () => { setPage(1); } }
						>
							{dict.modals.onboarding.page0.button}
							<i className='icon-arrow-right-full' />
						</button>
					</>}
					{page > 0 && <>
						<button 
							className='button__white'
							onClick={ () => { setPage(page - 1); } }
						>
							<i className='icon-arrow-left-full' />
							{dict.modals.onboarding.previous}
						</button>
						<div style={ { textAlign: "center" } }>
							{page} z 5
						</div>
						{(page === 1 || page === 2 || page === 3 || page === 4) &&
							<button 
								className='button__blue'
								onClick={ () => { setPage(page + 1); } }
								style={ { marginLeft: 'auto' } }
							>
								{dict.modals.onboarding.next}
								<i className='icon-arrow-right-full' />
							</button>}
						{(page > 4) &&
							<button 
								className='button__blue'
								onClick={ finishIntroduction }
								style={ { marginLeft: 'auto' } }
							>
								{dict.modals.onboarding.page5.button}
							</button>}
					</>}
				</div>
			</div>
		</div>
	);
};

export default ModalOnboarding;